// src/utils/examWindow.ts

export const EXAM_WINDOW_NAME = "eduvic_exam_lobby";

export const openExamWindow = (url: string): void => {
  const width  = 1200;
  const height = 740;
  const left   = window.screenX + (window.outerWidth  - width)  / 2;
  const top    = window.screenY + (window.outerHeight - height) / 2;

  const features =
    `width=${width},height=${height},top=${top},left=${left},` +
    `resizable=yes,scrollbars=yes,status=no,toolbar=no,menubar=no,location=no`;

  const w = window.open(url, EXAM_WINDOW_NAME, features);
  if (w) w.focus();
};